// OpportunityHeader.jsx
import React, { useEffect, useState } from 'react';
import { Badge, Button, Form, Col, Row } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import './opportunity-header.css';
import Modal_proyectos from '../../menus/Modal';
import Card_link from './modals/Card_link';
import Team_link from './modals/Team_link';
import Channels_link from './modals/Channels_link';
import { add_card_to_opportunity, add_opportunity_project, add_user_permission, delete_opportunity, insert_new_opportunity, load_opportunity, load_opportunity_cards, load_opportunity_projects, opportunity_status_change, remove_card_link, remove_linked_project, remove_permission, send_newLogEntry } from '../../../utils/crm_services';
import { loadCountriesData, buildCountrySelectOptions, buildCountryPhoneOptions } from '../../../utils/countries';
import { ensure_card } from '../../../utils/talent_services';
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';
import Won_lost from './modals/Won_lost';
import Member_profile from './modals/Member_profile';
import Project_link from './modals/Project_link';

export default function OpportunityHeader({
  /* ---------- datos de la izquierda ---------- */
  opportunityName = 'Opportunity Name',
  token,
  opportunity_id, 
  usr_type,
  usr_id,
  cards = []
}) {

    const navigate = useNavigate();
    const [editableOpportunityName, setEditableOpportunityName] = useState(opportunityName);
    const [isNameEdited, setIsNameEdited] = useState(false); // State to track if name is edited
    const [description, setDescription] = useState('');
    const [channel_id, setChannelid] = useState(null);
    const [channel_name, setChannelName] = useState('');
    const [team, setTeammember] = useState([ ]);
     const [created_by, setCreatedBy] = useState([ ]);
    const [strategies, setStrategies] = useState([ ]);
    const [country, setCountry] = useState('');
    const [type, setType] = useState(0);
    const [stage, setStage] = useState(0);
    const [oppStatus, setStatus] = useState(0);
    const [strategyCost, setStrategyCost] = useState(0);
    const [closingDate, setClosingDate] = useState('');
    const [oldClosing, setOldClosing] = useState('');
    const [oldProtected, setOldProtected] = useState('');
    const [protectedUntil, setProtectedUntil] = useState('');
    const [countryOptions, setcountryOptions] = useState([]);
    const [countryPhoneOptions, setCountryPoneOptions] = useState([]);
    const [projects, setprojects] = useState([]);
    const [modal_param_usr, setmodal_param_usr] = useState(0);
    const typeOptions = [
        { label: 'Public', value: 0 },
        { label: 'Private', value: 1 },
        { label: 'Online', value: 2 }
      ];

      const stageOptions = [
        { label: 'Viewed', value: 20 },
        { label: 'Quoated', value: 40 },
        { label: 'Accepted', value: 60 },
        { label: 'Waiting PO', value: 80 },
        { label: 'WON', value: 100 },
      ];
    
       const LOOKER_REPORT_IDS = {
    es: '334f6121-5216-4e26-8827-0747b360d218', // Dashboard en Español
    en: '4236b00a-6559-4631-90dc-0943e5aeba9e'  // Dashboard en English
  };
     
    let [modal_content, setmodal_content] = useState("");

    useEffect(() => {
        if (opportunity_id !== null) {
            if(opportunity_id==="new"){
                setIsNameEdited (true);
                setEditableOpportunityName ("New Opportunity");
            }else{
                load_opportunity_data(opportunity_id);
                fetchloadCards(opportunity_id);
                fetchloadOppProjects(opportunity_id);
                setIsNameEdited(false);
            }
        }
    }, [opportunity_id]); 
    
   


    useEffect(() => {
        loadCountriesData()
          .then((data) => {
            setcountryOptions(buildCountrySelectOptions(data));
            setCountryPoneOptions(buildCountryPhoneOptions(data));
          })
          .catch((error) => console.error('Error fetching countries:', error));
      }, []);

    async function fetchloadOppProjects(opportunity_id) {
        const cardList = await load_opportunity_projects(token,opportunity_id);
        if (cardList==="INVALID"){
            navigate("/");
        }else{
            let totalCost = 0;
           const temp = cardList["opp_proj"].map((celement, index) => {
            totalCost += parseFloat(celement.cardCost);
            return {
                name: celement.project_name,
                country: celement.country,
                link_token: celement.link_token,
                project_id: celement.project_id,
                id: celement.id,
                index:index
            };
          });

          

           setprojects(temp);

        }
    }

    async function fetchloadCards(opportunity_id) {
        const cardList = await load_opportunity_cards(token,opportunity_id);
        if (cardList==="INVALID"){
            navigate("/");
        }else{
            let totalCost = 0;
           const tempStrategies = cardList["opp_cards"].map((celement, index) => {
            totalCost += parseFloat(celement.cardCost);
            return {
                link_id: celement.link_id,
                trello_card_id: celement.trello_card_id,
                shortURL: celement.shortURL,
                title: celement.title,
                index:index
            };
          });
       
           setStrategies( tempStrategies);
           setStrategyCost(totalCost);

        }
    }



    const load_opportunity_data=(opportunity_id)=>{
        async function fetchloadOpportunity(opportunity_id) {
        const opportunityList = await load_opportunity(token,opportunity_id);
        if (opportunityList==="INVALID"){
            navigate("/");
        }else{
           const oppData = opportunityList?.["opp_data"];
           if (!Array.isArray(oppData) || oppData.length === 0) {
              console.warn("load_opportunity returned empty opp_data", { opportunity_id, opportunityList });
              return;
           }

           const opp0 = oppData[0];

           setEditableOpportunityName(opp0?.name ?? '');
           setDescription(opp0?.description ?? '');
           setChannelid(opp0?.channel_id ?? null);
           setChannelName(opp0?.channel_name ?? '');
           setProtectedUntil(opp0?.protectedUntil ?? '');
           setClosingDate(opp0?.closing_date ?? '');
           setCountry(opp0?.country ?? '');
           setType(opp0?.type ?? 0);
           setStage(opp0?.stage ?? 0);
           setStatus(parseInt(opp0?.current_status ?? 0));

           document.title = (opp0?.name ?? '') + " - TOMi Management";

           const permissionData = Array.isArray(opportunityList?.["permission_data"])
             ? opportunityList["permission_data"]
             : [];

           const tempTeam = permissionData.map((celement, index) => {
            return {
              permission_id: celement.permission_id,
              usr_name: celement.usr_name==="" ? celement.email_id : celement.usr_name,
              usr_id: celement.usr_id,
              usr_type: celement.type,
                  email: celement.email_id,
              index:index
            };
          });

           setCreatedBy(opp0?.created_by ?? '');

           setTeammember( [{permission_id:0, 
                                usr_id:opp0?.created_by ?? '',
                                usr_name:opp0?.owner_name ?? '',
                                email:opp0?.email_id ?? '',
                                usr_type:4
           },...tempTeam]); //usr_type: es el creador y owner
           
          //usr_type:
          //4 - Owner de esta oportunidad
          //0 - Usuario de TOMi
          //1 - Usuario del Mayorista
          //2 - Usuario del canal
            
        }
        }
        fetchloadOpportunity(opportunity_id);
        setIsNameEdited(false);
    }

    const handleNameChange = (event) => {
        const newValue = event.target.value;
        setEditableOpportunityName(newValue);
        if (!isNameEdited)
            setIsNameEdited(true);
    };

    const [isModalOpen, setModalOpen] = useState(false);

    const setNewStrategy =(trello_id, title, shortURL, descript, kr_trello_id)=>{
        addStrategy(trello_id, title, shortURL, descript, kr_trello_id);
        setModalOpen(false);
    }

    const setLinkedChannel =(id, title)=>{
        setChannelName(title);
        setChannelid(id);
        setIsNameEdited(true);
        setModalOpen(false);
    }


    const setNewMember =(id)=>{
        setModalOpen(false);
        addUserPermission(id);
    }

     const setProject =(id)=>{
        addOpportunityProject(id);
        setModalOpen(false);
       

    }
    


    //--------------------- LINKING ELEMENTS
    const createNewOpportunity =() =>{
        
          async function fetchcreateNew(name, channel_id) {
              
            const opportunityList = await insert_new_opportunity(token,name,channel_id, description, protectedUntil, closingDate, country, type, stage, oppStatus, opportunity_id);
            if (opportunityList==="INVALID"){
              navigate("/");
            }else if (opportunityList==="UPDATED"){
              if ((oldClosing !=='' && oldClosing !== closingDate) ||(oldProtected !=='' && oldProtected !== protectedUntil)) 
                sendNewLogEntry();

              load_opportunity_data(opportunity_id);
            }else{
              navigate("/opportunitypage?id=" + opportunityList);
           }
          }

          fetchcreateNew(editableOpportunityName, channel_id);
   
    }

      async function sendNewLogEntry() {

        const productList = await send_newLogEntry(token,opportunity_id, "Old closing date " + oldClosing, 1);
        if (productList==="INVALID"){
            navigate("/");
        }else{
          // load_log();
    
        }
      }

  async function addUserPermission(email_id) {
    console.log("Adding user to opportunity: " + email_id);
      const addUserPerm = await add_user_permission(token,opportunity_id, email_id);
      if (addUserPerm==="INVALID"){
        navigate("/");
      }else{
        load_opportunity_data(opportunity_id);
        if (addUserPerm && typeof addUserPerm === 'object') {
          if (addUserPerm.status === 'ERROR' || addUserPerm.status === 'FORBIDDEN') {
            alert(addUserPerm.message || 'No se pudo completar la acción.');
            return;
          }
          if (addUserPerm.status === 'PARTIAL') {
            const detail = addUserPerm.notification_exception
              ? ` Detalle técnico: ${addUserPerm.notification_exception}`
              : '';
            alert((addUserPerm.message || 'Contacto agregado con advertencias de notificación.') + detail);
            return;
          }
          if (addUserPerm.email_sent === true || addUserPerm.push_sent === true) {
            alert('Notificación Enviada');
          } else if (addUserPerm.inserted === false) {
            alert(addUserPerm.message || 'El contacto ya estaba vinculado o no se pudo agregar.');
          } else if (addUserPerm.user_registered === false) {
            alert(addUserPerm.message || 'Contacto agregado. No se envía notificación porque el contacto no tiene cuenta en la plataforma.');
          } else {
            const detail = addUserPerm.email_error ? ` Detalle correo: ${addUserPerm.email_error}` : '';
            alert((addUserPerm.message || 'No se pudo enviar notificación por correo ni push.') + detail);
          }
        }
    }
  }
 

  async function addOpportunityProject(project_id) {
    console.log("Adding project to opportunity: " + project_id);
      const addUserPerm = await add_opportunity_project(token,opportunity_id, project_id);
      if (addUserPerm==="INVALID"){
        navigate("/");
      }else{
       fetchloadOppProjects(opportunity_id);
    }
  }

    async function addStrategy(trello_id, title, shortURL, descript, kr_trello_id) {
        const ensureResult = await ensure_card(token, trello_id, title ?? '', shortURL ?? null, descript ?? null, kr_trello_id ?? null);
        if (ensureResult === "INVALID" || ensureResult?.error === "INVALID") {
          navigate("/");
          return;
        }
        const addUserPerm = await add_card_to_opportunity(token,opportunity_id, trello_id);
        if (addUserPerm==="INVALID"){
          navigate("/");
        }else{
            fetchloadCards(opportunity_id);
        }
    }

    async function removePermission(permission_id) {

        const addUserPerm = await remove_permission(token,permission_id);
        if (addUserPerm==="INVALID"){
          navigate("/");
        }else{
          load_opportunity_data(opportunity_id);
       }
    }

        async function removeProject(link_id) {

        const addUserPerm = await remove_linked_project(token,link_id);
        if (addUserPerm==="INVALID"){
          navigate("/");
        }else{
          fetchloadOppProjects(opportunity_id);
       }
    }
    
    
    async function   onRemoveStrategy (link_id) {

        const addUserPerm = await remove_card_link(token,link_id);
        if (addUserPerm==="INVALID"){
          navigate("/");
        }else{
            fetchloadCards(opportunity_id);
       }
    }

        const formatOptionLabel = ({ label, flagUrl }) => (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          {flagUrl && <img src={flagUrl} alt={`Flag of ${label}`} style={{ width: '20px', marginRight: '10px' }} />}
          <span>{label}</span>
        </div>
      );

       const deleteOpportunity = (recordId) => {
                const isConfirmed = window.confirm('Are you sure you want to delete this opportunity?');

                if (isConfirmed) {
                    // Lógica para eliminar el registro
                  validate_opportunity(4,"Annulated");
                }
        };



      const getOptionByValue = (value) => {
        return countryOptions.find(option => option.value === value);
      };
      const getTypeByValue = (value) => {
        return typeOptions.find(option => option.value === value);
      };
      const getStageByValue = (value) => {
        return stageOptions.find(option => option.value ===Number( value));
      };


    const handleOpenLookerDashboard = (project, language = 'es') => {
    // Parámetros del proyecto para el dashboard
    const params = {
      "ds3.project": project.link_token,
      "ds3.project_name": project.name,
      "ds0.country_": project.country,
      "ds84.project": project.link_token,
      "ds97.project_name": project.name,
      "ds0.project_name": project.name,
      "ds97.country_": project.country,
      "ds0.project": project.link_token,
      "ds12.project": project.link_token,
      "ds97.project": project.link_token,
      "ds68.project": project.link_token,
      "ds120.project": project.link_token,
      "ds70.project": project.link_token,
      "ds72.project": project.link_token,
      "ds74.project": project.link_token,
      "ds88.project": project.link_token,
      "ds89.project": project.link_token,
      "ds94.project": project.link_token,
    };

    // Obtener el ID del reporte según el idioma
    const reportId = LOOKER_REPORT_IDS[language] || LOOKER_REPORT_IDS.es;

    // Construir la URL del dashboard
    const lookerUrl = `https://lookerstudio.google.com/u/0/reporting/${reportId}/page/p_4t028esnmd?params=${encodeURIComponent(JSON.stringify(params))}`;

    // Abrir en nueva pestaña
    window.open(lookerUrl, '_blank', 'noopener,noreferrer');
  };
      

      async function validate_opportunity(destinyStatus, thedescription) {
       
        const cardList = await opportunity_status_change(token, opportunity_id, destinyStatus, thedescription);
        if (cardList==="INVALID"){
            navigate("/");
        }else{
           setModalOpen(false);
           load_opportunity_data(opportunity_id);
                       
        }
    }


  return (
    <header className="container-fluid border-bottom pb-3 mb-4 full_container">

    <Modal_proyectos isOpen={isModalOpen} onClose={() => setModalOpen(false)} 
        title={
                modal_content === 'Card_link' ? 'Add strategy' :
                modal_content === 'Team_link' ? 'Add team member' :
                modal_content === 'Project_link' ? 'Add Project' :
                modal_content === 'Member_profile' ? 'Member Profile' :
                modal_content === 'Channels_link' ? 'Transferir to reseller' :
                ''
            }
    >  
        {modal_content === 'Member_profile'  &&  <Member_profile token={token} modal_param_usr_email={modal_param_usr} countryOptionsMnu={countryOptions} countryPhoneOptionsMnu={countryPhoneOptions}  channel_id={channel_id} onClose={() => setModalOpen(false)}></Member_profile>}  
        {modal_content === 'Card_link'  &&  <Card_link token_num={token} onSet={(trello_id, title, shortURL, descript, kr_trello_id) => setNewStrategy(trello_id, title, shortURL, descript, kr_trello_id)} initialRows={Array.isArray(cards) ? cards.filter(c => !c.isKr).map(c => ({ id: c.cardid, trello_card_id: c.cardid, title: c.cardname, shortURL: c.shortUrl, desc: c.desc, kr_trello_id: c.krid })) : []}></Card_link>}
        {modal_content === 'Team_link'  &&  <Team_link  onSet={(id) => setNewMember(id)}></Team_link>}
        {modal_content === 'Project_link'  &&  <Project_link token_num={token}  onSet={(id) => setProject(id)}></Project_link>}
        {modal_content === 'Channels_link'  &&  <Channels_link token={token}  onSet={(id, channel_name) => setLinkedChannel(id, channel_name)}></Channels_link>}
        {modal_content === 'WON'  &&  <Won_lost newStatus={2}  onSet={(thedescription) => validate_opportunity(2,thedescription )}></Won_lost>}
        {modal_content === 'LOST'  &&  <Won_lost newStatus={3}  onSet={(thedescription) => validate_opportunity(3, thedescription)}></Won_lost>}
              
    </Modal_proyectos>

    <div className="row align-items-stretch gy-3 ">
    {/* ================================================================
        Columna IZQUIERDA (1 de 2) -- Datos básicos
    ================================================================= */}
    <div className="col-lg-8">
    <Row className="gy-4 mb-2">
        {/* ----------------- Título ----------------- */}
        <Col xs={12} md={8}>
            <div className="d-flex align-items-start gap-2">
                <Button
                    variant="link"
                    className="text-secondary text-decoration-none p-0 mt-1"
                    onClick={() => navigate(-1)}
                    title="Volver atrás"
                    aria-label="Volver atrás"
                >
                    <span className="fs-3">←</span>
                </Button>
                <div className="flex-grow-1">
                    <div className="label-normal">
                    Opportunity Name:
                    </div>
                    <input
                            type="text"
                            className="display-5 fw-bold mb-0 text-start opportunity-name-input"
                            value={editableOpportunityName}
                            onChange={handleNameChange}
                    />
                </div>
            </div>
        </Col>

  

         <Col xs={12} md={4}>
           

                <div  style={{ cursor: "pointer" }} onClick={() => {
                    setmodal_content("Channels_link");
                    setModalOpen(true);
                }} className="d-flex align-items-center mb-3">
                <div>
                    {channel_name ? (
                        <Badge pill bg="primary" className="chip d-inline-flex align-items-center gap-2 px-3 py-2 fs-8">
                            
                            {channel_name && channel_name.length > 25
                                ? channel_name.slice(0, 25) + '...'
                                : channel_name}
                        </Badge>
                    ) : (
                        <Button variant="outline-primary" size="sm"> 
                            Link Channel
                        </Button>
                    )}
                </div>
            </div>

           
            {/* ------------ Botón del Switch en su propia línea --------------- */}
            {/* No necesitas un div adicional si quieres que el botón ocupe todo el ancho de la columna
                y el propio botón ya tiene la clase w-100 */}
            {(() => {
                switch (oppStatus) {
                case 0:
                    if(parseInt(usr_type) ==0){
                        return (
                        <Button
                            variant="danger"
                            size="sm"
                            className="w-100" // w-100 asegura que ocupe todo el ancho de la columna
                            onClick={() => {
                                validate_opportunity(1, "Validated");
                            }}
                        >
                            Validate
                        </Button>
                        );
                    }else{
                        return('');
                    }
                case 1:
                    return (
                    // Si quieres dos botones en la misma línea para oppStatus 1, necesitarás un div DENTRO de este case
                    <div className="d-flex gap-2"> {/* gap-2 para un pequeño espacio entre ellos */}
                        <Button
                        variant="success"
                        size="sm"
                        className="w-100" // Asegura que cada botón dentro del div ocupe la mitad
                        onClick={() => {
                            setmodal_content("WON");
                            setModalOpen(true);
                        }}
                        >
                        WON
                        </Button>
                        <Button
                        variant="danger"
                        size="sm"
                        className="w-100" // Asegura que cada botón dentro del div ocupe la mitad
                        onClick={() => {
                            setmodal_content("LOST");
                            setModalOpen(true);
                        }}
                        >
                        LOST
                        </Button>
                    </div>
                    );
                case 2:
                    return (
                        <Badge bg="success" className="w-100">
                        GANADO
                        </Badge>
                    );
                case 3:
                    return (
                        <Badge bg="danger" className="w-100">
                        PERDIDO
                        </Badge>
                    );
                case 4:
                    return (
                        <Badge bg="danger" className="w-100">
                        ANULADO
                        </Badge>
                    );
                default:
                    return null;
                }
            })()}
            </Col>
    </Row>
        <div className="d-flex flex-wrap gap-2 justify-content-lg-end mt-auto mb-1 ">
            {/* Fila 3: Description full width */}
            <Col xs={12}>
                <Form.Group controlId="description">

                    <Form.Control
                    as="textarea"
                    rows={4}
                    value={description}
                    placeholder="Description..."
                    onChange={(e) => {
                        setIsNameEdited (true);
                        setDescription(e.target.value)
                    }}
                    />
                </Form.Group>
            </Col>
        </div>
        <Row className="gy-2 mb-2 gx-1">
                <Col xs={12} md={2}>
                        <Form.Group as={Row} controlId="protected-until">
                            <Form.Label column sm={12}>Protection:</Form.Label>
                        
                            <Col sm={12}>
                                <Form.Control
                                    type="date"
                                    value={protectedUntil}
                                    onChange={(e) =>{ 
                                        setIsNameEdited (true);
                                        setOldProtected(protectedUntil);
                                        setProtectedUntil(e.target.value);
                                    }}
                                />
                            </Col>
                            
                        </Form.Group>
                </Col>
            
                <Col xs={12} md={2}> {/* Nota: xs={20} es inusual, Bootstrap usa un sistema de 12 columnas. Quizás querías xs={12} o ajustar md */}
                        <Form.Group as={Row} controlId="closing-date">
                            <Form.Label column sm={12}>Closing:</Form.Label>
                            <Col sm={12}> {/* Ajustado sm={5} para que quepa mejor si Form.Label es sm={4} */}
                                <Form.Control
                                    type="date"
                                    value={closingDate}
                                    onChange={(e) => {
                                        setIsNameEdited (true);
                                        setOldClosing(closingDate);
                                        setClosingDate(e.target.value);
                                    }}
                                />
                            </Col>
                        </Form.Group>
                    </Col>
            
                {/* Fila 2: Country */}
                <Col xs={12} md={4}>
                    <Form.Group as={Row} controlId="country">
                    <Form.Label column sm={12}>Country:</Form.Label>
                        <Select
                            className="react-select-container"
                            classNamePrefix="react-select"
                            options={countryOptions}
                            isLoading={countryOptions.length === 0}
                            formatOptionLabel={formatOptionLabel}
                            onChange={(selectedOption) =>{
                                setIsNameEdited (true);
                                
                                 setCountry(selectedOption.value);
                                }}
                            value={getOptionByValue(country)}
                            placeholder="Country..."
                            isSearchable
                            styles={{
                                container: (provided) => ({
                                  ...provided,
                                  minWidth: 100, // o usa width: '100%' para expansión completa
                                  flex: 1,       // permite que crezca en d-flex
                                }),
                                  menu: (provided) => ({
                                      ...provided,
                                      zIndex: 9999 // Un valor alto para asegurar que aparezca encima de todo
                                  }),
                                  // Opcional: Si el menú se renderiza en un portal, también puedes ajustar su zIndex
                                  menuPortal: (base) => ({
                                      ...base,
                                      zIndex: 9999
                                  })
                              }}
                        />
                       
                    </Form.Group>
                </Col>
                {/* Fila 2: Type */} {/* Movido Type aquí para que esté en la misma fila visual que Country */}
                <Col xs={12} md={2}>
                    <Form.Group as={Row} controlId="type">
                    <Form.Label column sm={12}>Type:</Form.Label>
                       
                        <Select
                            className="react-select-container"
                            classNamePrefix="react-select"
                            options={typeOptions}
                            isLoading={typeOptions.length === 0}
                            onChange={(selectedOption) =>{
                                setIsNameEdited (true);
                                setType(selectedOption.value);
                            } }
                            placeholder="Type..."
                            value={getTypeByValue(parseInt(type))}
                            styles={{
                                container: (provided) => ({
                                  ...provided,
                                  minWidth: 100, // o usa width: '100%' para expansión completa
                                  flex: 1,       // permite que crezca en d-flex
                                }),
                                  menu: (provided) => ({
                                      ...provided,
                                      zIndex: 9999 // Un valor alto para asegurar que aparezca encima de todo
                                  }),
                                  // Opcional: Si el menú se renderiza en un portal, también puedes ajustar su zIndex
                                  menuPortal: (base) => ({
                                      ...base,
                                      zIndex: 9999
                                  })
                              }}
                        />
                        
                    </Form.Group>
                </Col>
                <Col xs={12} md={2}>
                    <Form.Group as={Row} controlId="type">
                    <Form.Label column sm={12}>Stage:</Form.Label>
                       
                        <Select
                            className="react-select-container"
                            classNamePrefix="react-select"
                            options={stageOptions}
                            isLoading={stageOptions.length === 0}
                            onChange={(selectedOption) => {
                                
                                if (selectedOption.value ==100){
                                  alert("Use the 'WON' green button stead");
                                  return;
                                }
                                setIsNameEdited (true);
                                setStage(selectedOption.value);
                                
                            }
                            }

                            placeholder="Stage..."
                            value={getStageByValue(stage)}
                            styles={{
                                container: (provided) => ({
                                  ...provided,
                                  minWidth: 100, // o usa width: '100%' para expansión completa
                                  flex: 1,       // permite que crezca en d-flex
                                }),
                                  menu: (provided) => ({
                                      ...provided,
                                      zIndex: 9999 // Un valor alto para asegurar que aparezca encima de todo
                                  }),
                                  // Opcional: Si el menú se renderiza en un portal, también puedes ajustar su zIndex
                                  menuPortal: (base) => ({
                                      ...base,
                                      zIndex: 9999
                                  })
                              }}
                        />
                        
                    </Form.Group>
                </Col>
                
              
        </Row>
        {/* The div below will be pushed to the bottom */}
        <div className="d-flex flex-wrap gap-2 justify-content-lg-end mt-auto ">
            {/* Conditionally render the Save Change button */}
            {isNameEdited && (
            <Button
                variant="danger"
                size="sm"
                onClick={()=>{createNewOpportunity()}}
                // Call the new save handler
            >
                Save Change
            </Button>
            )}
            {/* You might also want a Cancel button here if the name is edited */}
           
        </div>
    </div>

    {/* ================================================================
        Columna DERECHA (2 de 2) -- Contiene Strategies y Team
    ================================================================= */}
    <div className="col-lg-4 d-flex flex-column"> {/* 1. Contenedor flex en columna */}
  {parseInt(usr_type) == 0 && (
    <div className="d-flex flex-column mb-4"> {/* mb-4 para añadir espacio antes de la sección Team */}
      {/* Strategies Label and Button container */}
      <div className="d-flex align-items-center justify-content-lg-end mb-1">
        <div className="fw-normal me-auto">
          <h5 className="mb-0 fw-normal">Strategies: {/* mb-0 removes default bottom margin */}
            {strategyCost.toLocaleString('en-US', {
              style: 'currency',
              currency: 'USD', // Or your actual currency
              maximumFractionDigits: 0,
            })}
          </h5>
        </div>
        <div className="fw-normal">
          <Button
            variant="outline-dark"
            size="sm"
            className="square-btn"
            onClick={() => {
              setmodal_content("Card_link");
              setModalOpen(true);
            }}
          >
            +
          </Button>
        </div>
      </div>

      {/* Strategies Badges container */}
      <div className="d-flex flex-wrap gap-2 justify-content-lg-end">
        {strategies.map((s) => (
          <Badge
            key={s.id}
            bg="secondary"
            pill
            className="chip d-inline-flex align-items-center gap-2 px-3 py-2 fs-8"
           // onClick={() => window.open(s.shortURL, '_blank')}
            onClick={() => navigate(`/strategypage?cardid=${s.trello_card_id}`)}
            style={{ cursor: 'pointer' }}
          >
            {s.title && s.title.length > 35
              ? s.title.slice(0, 35) + '...'
              : s.title}
            <button
              aria-label={`Remove ${s.title}`}
              className="btn-close btn-close-white btn-close-sm ms-1"
              onClick={(e) => {
                e.stopPropagation();
                onRemoveStrategy(s.link_id);
              }}
            />
          </Badge>
        ))}
      </div>
    </div>
  )}

  {/* ----- Sección Team (anteriormente "Columna centro") ----- */}
  <div className="mb-3"> {/* Añadido mb-3 para espacio si Strategies no está, o entre Team y Delete */}
    <div className="d-flex align-items-center mb-2">
      <h5 className="me-2 mb-0 fw-normal">Contacts:</h5>
      <Button
        variant="outline-dark"
        size="sm"
        className="square-btn"
        onClick={() => {
          setmodal_content("Team_link");
          setModalOpen(true);
        }}
      >
        +
      </Button>
    </div>

    <div className="d-flex flex-wrap gap-2">
      {team.map((m) => (
        <Badge
          key={m.permission_id}
          bg={m.usr_type == 4 ? 'warning' : m.usr_type == 0 ? 'info' : m.usr_type == 1 ? 'secondary' : 'danger'}
          pill
          style={{ cursor: 'pointer' }} 
          className="chip d-inline-flex align-items-center gap-2 px-3 py-2 fs-8"
           onClick={() => {
                            setmodal_param_usr (m.email);
                            setmodal_content("Member_profile");
                            setModalOpen(true);
                    }}
        >
          {m.usr_name}
          {m.usr_type != 4 &&
            <button
              aria-label={`Remove ${m.usr_name}`}
              className="btn-close btn-close-white btn-close-sm ms-1"

            onClick={(e) => { // 👈 Recibe el objeto del evento
                                        e.stopPropagation(); // 👈 ¡Detiene la propagación!
                                        removePermission(m.permission_id);
                                    }}
            />
          }
        </Badge>
      ))}
    </div>
  </div>

   <div className="mb-3"> {/* Añadido mb-3 para espacio si Strategies no está, o entre Team y Delete */}
    <div className="d-flex align-items-center mb-2">
      <h5 className="me-2 mb-0 fw-normal">Projects/Pilots:</h5>
     
     {parseInt(usr_type) == 0 &&
      <Button
        variant="outline-dark"
        size="sm"
        className="square-btn"
        onClick={() => {
          setmodal_content("Project_link");
          setModalOpen(true);
        }}
      >
        +
      </Button>
  }
    </div>

    <div className="d-flex flex-wrap gap-2">
      {projects.map((m) => (
        <Badge
          key={m.permission_id}
          bg={m.usr_type == 4 ? 'warning' : m.usr_type == 0 ? 'info' : m.usr_type == 1 ? 'secondary' : 'danger'}
          pill
          style={{ cursor: 'pointer' }} 
          className="chip d-inline-flex align-items-center gap-2 px-3 py-2 fs-8"
           onClick={() => {
                       handleOpenLookerDashboard(m, 'es');
                    }}
        >
          {m.name}
        
            <button
              aria-label={`Remove ${m.usr_name}`}
              className="btn-close btn-close-white btn-close-sm ms-1"

            onClick={(e) => { // 👈 Recibe el objeto del evento
                                        e.stopPropagation(); // 👈 ¡Detiene la propagación!
                                        removeProject(m.id);
                                    }}
            />
          
        </Badge>
      ))}
    </div>
  </div>

{usr_id==created_by && (
  <div className="mt-auto pt-3"> {/* 2. Margen superior automático y un poco de padding arriba */}
    {/* El div que contenía d-flex align-items-center mb-2 para el botón se puede simplificar o ajustar */}
    <div>
      <Button
        variant="danger"
        size="sm"
        className="w-100" // Asegura que el botón ocupe todo el ancho
        onClick={() => {
          deleteOpportunity();
        }}
      >
        DELETE OPPORTUNITY
      </Button>
    </div>
  </div>
  )}
</div>
</div>
    </header>
  );
}
